export default __webpack_public_path__ + "static/media/cz.9a3755fa.svg";